var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import triggerAnalytics from "../../../helpers/triggerAnalytics";
import { ERRORS, PAGE_NAME, PAGE_SUBFUNCTIONS } from "../../../const/analytics";
import i18n from "../../../strings/i18n";
import { BodyWrapper, ErrorDescription, ErrorHeaderWrapper, ErrorImage, ErrorImageContainer, FooterButton, FooterWrapper, Header, ModalBody, } from "./LoanNickNameModal.styles";
import en from "../../../strings/lang/en";
var nicknameError = en.labels.nicknameError;
var NickNameError = function (_a) {
    var img = _a.img, handleClose = _a.handleClose, clientName = _a.clientName, type = _a.type;
    useEffect(function () {
        if (clientName) {
            triggerAnalytics({
                pageSubFunction: PAGE_SUBFUNCTIONS.LOAN_NICKNAME,
                clientName: clientName,
                message: nicknameError,
                messageType: ERRORS.API_FAILURE,
                pageName: PAGE_NAME.ERROR,
                errorMessage: ERRORS.ERROR_MESSAGE,
                previouslyVisited: window.location.pathname,
                product: type,
            });
        }
    }, [clientName, type]);
    return (_jsxs(_Fragment, { children: [_jsx(ErrorHeaderWrapper, __assign({ "data-testid": "nickname-error-header" }, { children: _jsx(Header, { children: i18n({ labels: "generalError" }) }) })), _jsxs(BodyWrapper, { children: [_jsx(ErrorImageContainer, { children: _jsx(ErrorImage, { src: img }) }), _jsx(ErrorDescription, { children: _jsx(ModalBody, { children: i18n({ labels: "nicknameError" }) }) })] }), _jsx(FooterWrapper, { children: _jsx(FooterButton, __assign({ "data-type": "loan nickname", "data-reason": "close", "data-object": "button", "data-analytics": "clicktrackingevent", id: "nickname-close", ariaLabel: "Close nickname modal", buttonType: "ghost", onClick: handleClose }, { children: i18n({ button: "close" }) })) })] }));
};
export default NickNameError;
//# sourceMappingURL=NickNameError.js.map